const stateName = '[ReferenceYear] ';

export class SharedGetReferenceYearsListAction {
    static readonly type = stateName + 'GetReferenceYearsList';

    constructor() {
    }
}

export class SharedLightGetReferenceYearsListAction {
    static readonly type = stateName + 'GetLightReferenceYearsList';

    constructor() {
    }
}

export class SharedGetReferenceMotorDatesListAction {
    static readonly type = stateName + 'GetReferenceMotorDateList';

    constructor() {
    }
}

export class SharedGetPeriodsListAction {
    static readonly type = stateName + 'GetPeriodsListAction';

    constructor() {
    }
}
